import { render, staticRenderFns } from "./UserGroupDetails.vue?vue&type=template&id=fa5b1ee4&scoped=true&"
import script from "./UserGroupDetails.vue?vue&type=script&lang=ts&"
export * from "./UserGroupDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5b1ee4",
  null
  
)

export default component.exports